export default "__VITE_ASSET__eVDcdD6Q__"